import { createContext, useContext } from 'react';

export const ParameterDeclarationContext = createContext(undefined);
export const ParameterDeclarationProvider = ParameterDeclarationContext.Provider;

export const useParameterDeclarationContext = <T>() => {
  return useContext<T>(ParameterDeclarationContext);
};
